import { render } from "./B2bPageDeliveryNotesEmit.vue?vue&type=template&id=58c6ca02&scoped=true&lang=pug"
import script from "./B2bPageDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bPageDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bPageDeliveryNotesEmit.vue?vue&type=style&index=0&id=58c6ca02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c6ca02"]])

export default __exports__